import { Trans, useTranslation } from 'react-i18next';
import LegalLayout from './LegalLayout';
import useSeo from '../../seo/useSeo';

// 서비스 이용약관 — 토이플(Toyple) / Lansly
// 사업 구조:
//  · Lansly SaaS 구독(AI 스케쥴링): 회사가 직접 제공하는 유료서비스 (해외 PG: Polar)
//  · 챌린지 / 외주 / 전문가 재능마켓: 회사는 통신판매중개자 (국내 PG: 포트원)
export default function Terms() {
  const { t } = useTranslation('legal');
  useSeo({ page: 'terms', path: '/terms' });
  // 조항 본문의 각 호(리스트)는 배열 키로 관리해 언어별로 자연스럽게 렌더링한다.
  const list = (key) => t(key, { returnObjects: true });

  return (
    <LegalLayout>
      <h1 className="legal-title">{t('terms.title')}</h1>
      <p className="legal-meta">
        {t('terms.effectiveLabel')}: {t('biz.docDate')} · {t('terms.announcedLabel')}:{' '}
        {t('biz.docDate')}
      </p>
      <p className="legal-intro">
        <Trans t={t} i18nKey="terms.intro" components={{ strong: <strong /> }} />
      </p>

      <section className="legal-section">
        <h2>{t('terms.art1Title')}</h2>
        <p>{t('terms.art1Body')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art2Title')}</h2>
        <p>{t('terms.art2Intro')}</p>
        <ol>
          {list('terms.art2Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art3Title')}</h2>
        <ol>
          {list('terms.art3Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art4Title')}</h2>
        <p>{t('terms.art4Body')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art5Title')}</h2>
        <p>{t('terms.art5Intro')}</p>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                {list('terms.art5Head').map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {list('terms.art5Rows').map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p>{t('terms.art5Note')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art6Title')}</h2>
        <ol>
          <li>{t('terms.art6Item1')}</li>
          <li>
            {t('terms.art6Item2Lead')}
            <ul>
              {list('terms.art6Item2Sub').map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </li>
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art7Title')}</h2>
        <ol>
          {list('terms.art7Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art8Title')}</h2>
        <ol>
          {list('terms.art8Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art9Title')}</h2>
        <p>{t('terms.art9Intro')}</p>
        <ul>
          {list('terms.art9Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art10Title')}</h2>
        <div className="legal-highlight">
          <p>
            <Trans t={t} i18nKey="terms.art10Highlight" components={{ strong: <strong /> }} />
          </p>
        </div>
        <ol>
          {list('terms.art10Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art11Title')}</h2>
        <ol>
          {list('terms.art11Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art12Title')}</h2>
        <ol>
          {list('terms.art12Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art13Title')}</h2>
        <ol>
          {list('terms.art13Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art14Title')}</h2>
        <div className="legal-highlight">
          {/* 핵심 문구만 부분 볼드 — 강조/일반 분리 구조 유지 */}
          <p>
            {t('terms.art14HighlightPre')}
            <strong>{t('terms.art14HighlightStrong')}</strong>
            {t('terms.art14HighlightPost')}
          </p>
        </div>
        <ol>
          {list('terms.art14Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art15Title')}</h2>
        <ol>
          {list('terms.art15Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art16Title')}</h2>
        <ol>
          {list('terms.art16Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art17Title')}</h2>
        <ol>
          {list('terms.art17Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art18Title')}</h2>
        <p>
          <Trans t={t} i18nKey="terms.art18Body" components={{ strong: <strong /> }} />
        </p>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art19Title')}</h2>
        <ol>
          {list('terms.art19Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('terms.art20Title')}</h2>
        <ol>
          {list('terms.art20Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <div className="legal-info-box">
        <h2>{t('biz.heading')}</h2>
        <dl>
          <dt>{t('biz.companyLabel')}</dt>
          <dd>토이플(Toyple)</dd>
          <dt>{t('biz.ceoLabel')}</dt>
          <dd>백경인</dd>
          <dt>{t('biz.regNoLabel')}</dt>
          <dd>601-55-00778</dd>
          <dt>{t('biz.mailOrderLabel')}</dt>
          <dd>2025-서울강동-0817</dd>
          <dt>{t('biz.addressLabel')}</dt>
          <dd>서울특별시 강동구 성내동 37-48, 2동 302호</dd>
          <dt>{t('biz.phoneLabel')}</dt>
          <dd>+82-10-8515-1619</dd>
          <dt>{t('biz.emailLabel')}</dt>
          <dd>admin@toyple.net</dd>
        </dl>
      </div>
    </LegalLayout>
  );
}
